import { PageHeading } from '@traceio-org/ui';
import { AdminPage } from '../components/AdminPage';
import { ActionLink } from '../components/AdminProblem';

export function NotFoundPage() {
  return (
    <AdminPage title="Page not found">
      <PageHeading title="Page not found" description="Trace Admin has no page at this address." />
      <div className="admin-problem-actions">
        <ActionLink primary to="/">
          Go to Health
        </ActionLink>
      </div>
    </AdminPage>
  );
}
